export const profileAttributes = [
  {
      name: 'code',
      label: 'Mã tài khoản',
      disabled: true,
      gridItem: {
          md:4
      }
  },
  {
      name: 'userName',
      label: 'Tên đăng nhập',
      disabled: true,
      gridItem: {
          md:4
      }
  },
  {
      name: 'fullName',
      label: 'Họ và tên',
      disabled: true,
      gridItem: {
          md:4
      }
  },
  {
      name: 'birthday',
      label: 'Ngày sinh',
      disabled: true,
      type: "date",
      gridItem: {
          md:3
      }
  },
  {
      name: 'gender',
      label: 'Giới tính',
      type: "gender",
      disabled: true,
      gridItem: {
          md:3
      }
  },
  {
      name: 'address',
      label: 'Địa chỉ',
      disabled: true,
      gridItem: {
          md:3
      }
  },
  {
      name: 'mariaged',
      label: 'Đã kết hôn',
      disabled: true,
      type: "checkbox",
      gridItem: {
          md:3
      }
  },
  {
      name: 'title',
      label: 'Trình độ',
      disabled: true,
      gridItem: {
          md:4
      }
  },
  {
      name: 'work',
      label: 'Chức vụ',
      disabled: true,
      gridItem: {
          md:4
      }
  },
  {
      name: 'departmentName',
      label: 'Phòng ban',
      disabled: true,
      gridItem: {
          md:4
      }
  },
]
